import React, { useCallback, useEffect, useState, useRef } from "react";
import styles from "../../assets/css/content.module.css";
import { useLocation } from "react-router-dom";
import {
  getProductDescriptionByProduct,
  postProductDescription,
  updateProductDescriptionByProduct,
} from "../../../services/index";
import { toast } from "react-toastify";
import JoditEditor from "jodit-react";
import { useFormik } from "formik";
import { nullToEmptyString } from "../../../utils/purefun";
import * as yup from "yup";

/* small id generator (no uuid dependency) */
const makeId = () => `${Date.now().toString(36)}-${Math.floor(Math.random() * 1e6).toString(36)}`;

export default function ProductExtraDetails() {
  const location = useLocation();
  const { data, type } = location.state || {};
  const productId = data?.id;
  const [isSaving, setIsSaving] = useState(false);
  const [recordId, setRecordId] = useState(null);
  const [isActive, setIsActive] = useState(true);
  const editorContentRef = useRef(nullToEmptyString(data?.description || ""));
  const formik = useFormik({
    initialValues: {
      title: nullToEmptyString(data?.name || ""),
      description: nullToEmptyString(data?.description || ''),
    },
    validationSchema: yup.object().shape({
      title: yup.string().required("Title is required"),
      description: yup.string().required("Description is required"),
    }),
    onSubmit: function (values) {
      // handleForm(values);
    },
  });
  // console.log("ProductExtraDetails isActive:", isActive);
  useEffect(() => {
    if (!productId) return;

    const fetchData = async () => {
      try {
        const res = await getProductDescriptionByProduct(type, productId);
        if (!res) return;

        // if (res.html) {
        //   formik.setFieldValue("description", res.html);
        // }
        if (res.html) {
          editorContentRef.current = res.html;
          formik.setFieldValue("description", res.html);
        }

        if (res.id) setRecordId(res.id);

        if (typeof res.is_active === "boolean") {
          setIsActive(res.is_active);
        }
      } catch (err) {
        console.error("Failed to fetch product description:", err);
      }
    };

    fetchData();
  }, [productId, type]);

  // Add block function - NOW WITH H3


  /* Save logic */
  const handleSave = async () => {
    if (!productId) {
      toast.warn("No product ID found");
      return;
    }

    setIsSaving(true);

    try {
      let idKey;

      if (type === "product") idKey = "productId";
      else if (type === "department") idKey = "departmentId";
      else if (type === "category") idKey = "categoryId";
      else if (type === "subcategory") idKey = "subcategoryId";

      const payload = {
        ...(idKey && { [idKey]: productId }),
        html: editorContentRef.current,
        is_active: isActive,
      };

      let res;

      if (recordId) {
        res = await updateProductDescriptionByProduct(type, productId, payload);
      } else {
        res = await postProductDescription(payload);
      }

      if (res) {
        if (res.id) setRecordId(res.id);
        toast.success("Saved successfully!");
      }
    } catch (err) {
      console.error(err);
      toast.error("Save failed");
    } finally {
      setIsSaving(false);
    }
  };

  /* UI */
  return (
    <div style={styles.wrapper}>
      <div style={styles.header}>
        <h1 style={styles.title}>
          {data?.equip_name
            ? `${data.equip_name}${data.brand ? ` - ${data.brand}` : ""}`
            : data?.name}
        </h1>
        <p style={styles.subtitle}>Create and manage detailed product descriptions</p>
      </div>
      <div className={styles.contFields}>
        <JoditEditor
          value={editorContentRef.current}
          config={{
            readonly: false,
            className: "custom-jodit-editor",
            uploader: {
              insertImageAsBase64URI: true,
            },

            askBeforePasteHTML: false,
            askBeforePasteFromWord: false,
            defaultActionOnPaste: "insert_as_html",

            processPasteHTML: true,

            cleanHTML: {
              cleanOnPaste: false,
              fillEmptyParagraph: false,
              removeEmptyElements: false,
            },
            disablePlugins: ["clean-html"],
            enter: "BR",
            defaultTag: "p",
          }}
          onChange={(newContent) => {
            editorContentRef.current = newContent; // no setState = no re-render
          }}
        />
      </div>
      <div style={{ marginTop: "20px", marginBottom: "20px" }}>
        <button
          onClick={handleSave}
          disabled={isSaving}
          style={{
            padding: "10px 20px",
            background: "#019c89",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          {isSaving ? "Saving..." : "Save"}
        </button>
      </div>

    </div>
  );
}
